import { PropsWithChildren } from 'react';
import { WEEKDAYS } from '@/constants/date.constants';

export const ScheduleCalendarGrid = ({ children }: PropsWithChildren) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-7">
        {WEEKDAYS.map((d) => (
          <div
            key={d}
            className="text-s-sb text-base-20 text-center py-2 bg-base-70 first:rounded-tl-lg last:rounded-tr-lg"
          >
            {d}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 border-s border-base-70">{children}</div>
    </div>
  );
};
